export default __webpack_public_path__ + "static/media/sun.354e4b97.svg";